import { showStatus } from './AxiosReqs';

export const createProduct = async function (formData) {
  try {
    showStatus('success', 'Uploading Product...');

    const res = await axios({
      method: 'POST',
      url: `/api/v1/products/create-product`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    });

    if (res.data.status === 'success') {
      showStatus('success', 'Product Added Successfully');
      window.setTimeout(
        () => location.assign(`/products?category=${formData.get('category')}`),
        1500
      );
    }
  } catch (error) {
    console.log(error);
    const errorMain = error.response.data.message;
    let errorMsg;
    if (window.innerWidth < 650) errorMsg = 'Product creation failed';
    else
      errorMsg = errorMain
        .replaceAll('Invalid Input data', '')
        .trim()
        .split('.')[0];
    setTimeout(() => showStatus('fail', errorMsg), 1500);
  }
};
